/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService
 */
import * as References from './AiAgentService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#isMaintenanceModeEnabled
 */
export const IS_MAINTENANCE_MODE_ENABLED_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_isMaintenanceModeEnabled';
export const IS_MAINTENANCE_MODE_ENABLED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: IS_MAINTENANCE_MODE_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.isMaintenanceModeEnabledRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#createAgent
 */
export const CREATE_AGENT_MUTATION_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_createAgent';
export const CREATE_AGENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_AGENT_MUTATION_FIELD_NAME,
  args: ['name', 'businessUnitId', 'role', 'personality', 'voice', 'configuredLanguages'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.createAgentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#updateAgentProfile
 */
export const UPDATE_AGENT_PROFILE_MUTATION_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_updateAgentProfile';
export const UPDATE_AGENT_PROFILE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_PROFILE_MUTATION_FIELD_NAME,
  args: ['name', 'role', 'personality', 'avatarFileId', 'voice', 'configuredLanguages', 'businessUnitId', 'aiAgentUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.updateAgentProfileRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAgentProfileByUserId
 */
export const GET_AGENT_PROFILE_BY_USER_ID_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAgentProfileByUserId';
export const GET_AGENT_PROFILE_BY_USER_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_PROFILE_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getAgentProfileByUserIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAgentByUserId
 */
export const GET_AGENT_BY_USER_ID_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAgentByUserId';
export const GET_AGENT_BY_USER_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_BY_USER_ID_QUERY_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getAgentByUserIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAiAgentOrThrowIfMultiple
 */
export const GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAiAgentOrThrowIfMultiple';
export const GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AI_AGENT_OR_THROW_IF_MULTIPLE_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getAiAgentOrThrowIfMultipleRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAiAgentsForPortal
 */
export const GET_AI_AGENTS_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAiAgentsForPortal';
export const GET_AI_AGENTS_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AI_AGENTS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['offset', 'deletedFilter', 'visibilityFilter', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getAiAgentsForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getAiAgentProfilesForPortal
 */
export const GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getAiAgentProfilesForPortal';
export const GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AI_AGENT_PROFILES_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getAiAgentProfilesForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getHydratedAiAgentDataForPortal
 */
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getHydratedAiAgentDataForPortal';
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getHydratedAiAgentDataForPortalRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#getHydratedAiAgentDataForPortalV2
 */
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_getHydratedAiAgentDataForPortalV2';
export const GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HYDRATED_AI_AGENT_DATA_FOR_PORTAL_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getHydratedAiAgentDataForPortalV2Rpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#deleteAgent
 */
export const DELETE_AGENT_MUTATION_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_deleteAgent';
export const DELETE_AGENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_AGENT_MUTATION_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.deleteAgentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#restoreAgent
 */
export const RESTORE_AGENT_MUTATION_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_restoreAgent';
export const RESTORE_AGENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESTORE_AGENT_MUTATION_FIELD_NAME,
  args: ['aiAgentUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.restoreAgentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService#migratePortalToNewHandoff
 */
export const MIGRATE_PORTAL_TO_NEW_HANDOFF_MUTATION_FIELD_NAME = 'com_hubspot_cv_ai_agents_configuration_rpc_AiAgentService_migratePortalToNewHandoff';
export const MIGRATE_PORTAL_TO_NEW_HANDOFF_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MIGRATE_PORTAL_TO_NEW_HANDOFF_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.migratePortalToNewHandoffRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});